









































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store";
import { apiService, Interfaces, AppConstants } from "../core/Export";
@Component({
  components: {},
})
export default class RedRouteStepFileUpload extends Vue {
  @Prop() fileToUploadParams;
  @Prop() filesFormData: FormData;
  isFileListReady: boolean = false;
  fileCodes = AppConstants.FileToUploadCodes;
  additionalAprovmentList: Array<any> = [];
  isDisabled = false;
  acceptableFiles = ["pdf", "jpg", "png", "jpeg"];

  tooltip: Array<boolean> = [];

  constructor() {
    super();
  }

  created() {
    this.onGetFileList();
  }

  toggleTooltip(index) {
    this.tooltip[index] = !this.tooltip[index];
    this.$forceUpdate();
  }

  onGetFileList() {
    this.isFileListReady = false;
    this.appEnv.isBusy = true;
    apiService
      .post("Request/GetFilesList", this.fileToUploadParams)
      .then((res) => {
        let response = res as Interfaces.ICallResult;
        if (response && response.isSuccess) {
          this.additionalAprovmentList =
            response.result["additionalAprovmentList"];
          store.commit("updateFileList", response.result["filesList"]);
          this.isFileListReady = true;
        } else {
          this.appEnv.showErrorDialog(response.msgs.errors);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onDeleteFile(fileCode) {
    let input = document.getElementById(fileCode);
    if (input) {
      let file = input["files"][0];
      if (file) {
        let existFileInFormData = this.filesFormData.has(fileCode);
        if (existFileInFormData) {
          this.filesFormData.delete(fileCode);
          input["value"] = "";
          let input_to_focus = document.createElement("input");
          document.body.appendChild(input_to_focus);
          input_to_focus.focus();
          input_to_focus.remove();
          this.getFileName(fileCode);
        }
      }
    }
  }

  isDeleteButtonVisible(fileCode) {
    return this.filesFormData.has(fileCode);
  }

  showFileSelect(id) {
    let fileElm = document.getElementById(id);
    if (fileElm) {
      fileElm.click();
    }
  }

  getFileName(fileCode) {
    let fileName = "";
    let file = this.fileList.find((s) => s.code == fileCode);
    let input = document.getElementById(fileCode);
    if (input) {
      let inputFile = input["files"][0];
      if (inputFile) {
        fileName = file.name + " - " + inputFile.name;
      } else {
        fileName = file.name;
      }
    } else {
      fileName = file.name;
    }
    return fileName;
  }

  onFileChanged(fileCode) {
    let input = document.getElementById(fileCode);
    if (input) {
      let file = input["files"][0];
      if (file) {
        let existFileInFormData = this.filesFormData.has(fileCode);
        if (existFileInFormData) {
          this.filesFormData.delete(fileCode);
        }
        if (file.size > AppConstants.MaxUploadSize) {
          this.appEnv.showErrorDialog([
            { message: "ניתן להעלות קובץ עד 10MB" },
          ]);
          input["value"] = "";
          return;
        }
        var name = file.name.toLowerCase(); 
        if (!name.endsWith(".pdf") && !name.endsWith(".jpg") && !name.endsWith(".png") && !name.endsWith(".jpeg")) {
          this.$q.notify({
            color: "negative",
            message:
              "ניתן להעלות את סוגי הקבצים הבאים בלבד: " + "PDF, JPG, PNG, JPEG",
            icon: "warning",
            position: "center",
          });
          input["value"] = "";
          return;
        }
        this.filesFormData.append(fileCode, file);
        let input_to_focus = document.createElement("input");
        document.body.appendChild(input_to_focus);
        input_to_focus.focus();
        input_to_focus.remove();
      }
    }
  }

  getUploadedFileName(fileCode: string) {
    let file = this.systemData["baseItems"].find((s) => s.code == fileCode);
    if (file) {
      return file.name;
    }
  }

  get uploadedFilesList() {
    let arr = store.getters.tRequestModel.filesList;
    // if (arr) {
    //   arr = arr.filter(s => s.code != AppConstants.FileToUploadCodes.Id);
    // }
    return arr;
  }

  get fileList() {
    return store.getters.fileList;
  }

  get systemData() {
    return store.getters.systemData;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
